module.exports = __webpack_public_path__ + "img/fetramovmg.721ea6fa.png";